import KBaseMapInfoWindow from "@/components/Maps/KBaseMapInfoWindow";
import { Address } from "kinnect-models";
import { Geocodable } from "kinnect-mixins";
import { MapElementMixin, gmapApi } from "vue2-google-maps";
import {
	VBottomSheet,
	VBtn,
	VCard,
	VCardActions,
	VCardText,
	VDivider,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle,
	VSpacer
} from "vuetify/lib";
import { formatLocation } from "kinnect-formatters";

export default {
	name: "KScheduleInfoWindow",

	inject: [ "storeModuleName" ],

	props: { schedule: Object },

	mixins: [
		Geocodable,
		MapElementMixin
	],

	data: vm => ( {
		changeAddressListener: null,
		originalLocation: Object.assign( {}, vm.schedule.address )
	} ),

	computed: {
		google: gmapApi,

		editMode: {
			get() {
				return this.$store.state[this.storeModuleName].editMode;
			},
			set( value ) {
				this.$store.dispatch( `${this.storeModuleName}/setEditMode`, Boolean( value ) );
			}
		},

		locationToGeocode() {
			return {
				lat: this.schedule.address.lat,
				lng: this.schedule.address.lng
			};
		},

		locationName() {
			if ( this.geocoderRunning ) {
				return "Loading...";
			} else if ( this.geocodedLocation ) {
				return this.geocodedLocation.name;
			}
		},

		genContentHeading() {
			if ( this.schedule.customer ) {
				return `${this.schedule.scheduleTypeNames} for ${this.schedule.customer.name}`;
			}

			return this.schedule.scheduleTypeNames;
		}
	},

	watch: {
		editMode( val ) {
			if ( val ) {
				this.geocode();

				this.changeAddressListener = this.google.maps.event.addListener( this.$map, "click", e => {
					const location = Object.assign( {}, this.schedule.address );

					location.lat = e.latLng.lat();
					location.lng = e.latLng.lng();

					this.updateLocation( location );
				} );
			} else if ( this.changeAddressListener ) {
				this.google.maps.event.removeListener( this.changeAddressListener );
			}
		}
	},

	methods: {
		updateLocation( location ) {
			this.schedule.address = location;
			this.geocode();
		},

		saveLocationChange() {
			this.schedule.address.address = [
				this.geocodedLocation.street_number,
				this.geocodedLocation.route
			].join( " " );
			this.schedule.address.city = this.geocodedLocation.locality;
			this.schedule.address.lat = this.geocodedLocation.latitude;
			this.schedule.address.lng = this.geocodedLocation.longitude;
			this.schedule.address.state = this.geocodedLocation.administrative_area_level_1;
			this.schedule.address.zip = this.geocodedLocation.postal_code;

			this.originalLocation = Object.assign( {}, this.schedule.address );

			const address = new Address( this.schedule.address );

			address.save();
		}
	},

	destroyed() {
		if ( this.changeAddressListener ) {
			this.google.maps.event.removeListener( this.changeAddressListener );
		}
	},

	render() {
		return <KBaseMapInfoWindow offsetY={-10} showPano>
			<VCard flat light>
				<VList class="list--auto-height" dense>
					<VListItem>
						<VListItemAction>
							<VIcon>local_shipping</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								{this.genContentHeading}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>

					{Boolean( this.schedule.salesOrders.length ) && <VListItem>
						<VListItemAction>
							<VIcon>format_list_bulleted</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								SO# {this.schedule.salesOrderNumbers}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>}

					{Boolean( this.schedule.purchaseOrders.length ) && <VListItem>
						<VListItemAction>
							<VIcon>format_list_bulleted</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								PO# {this.schedule.purchaseOrderNumbers}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>}

					{this.schedule.description && <VListItem>
						<VListItemAction>
							<VIcon>comment</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								{this.schedule.description}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>}

					<VListItem>
						<VListItemAction>
							<VIcon>place</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								{formatLocation( this.schedule.address )}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>
				</VList>

				{this.$can( "edit_addresses" ) && [
					<VDivider class="mt-4"></VDivider>,

					<VCardActions>
						<VSpacer></VSpacer>
						<VBtn
							color="link"
							onClick={() => this.editMode = true}
							text
						>
							<VIcon left>edit</VIcon>
							Change address
						</VBtn>
					</VCardActions>
				]}

				<VBottomSheet
					hideOverlay
					inset
					persistent
					value={this.editMode}
				>
					<VCard tile>
						<VCardText class="text-center">
							<p class="text-h6">Click on the map to move this schedule</p>

							<p class="text-subtitle-1">Selected Location: {this.locationName}</p>

							<VBtn
								class="ma-1"
								color="error"
								onClick={() => {
									this.updateLocation( this.originalLocation );
									this.editMode = false;
								}}
							>Cancel</VBtn>

							<VBtn
								class="ma-1"
								color="success"
								loading={this.geocoderRunning}
								onClick={() => {
									this.saveLocationChange();
									this.editMode = false;
								}}
							>Confirm</VBtn>
						</VCardText>
					</VCard>
				</VBottomSheet>
			</VCard>
		</KBaseMapInfoWindow>;
	}
};
